// ===== INTERNATIONAL PROGRAMS (SAT) =====
const INTERNATIONAL = [
  {
    id: "sat-engg",
    name: "B.S./B.Eng in Engineering (Abroad via SAT)",
    stream: "all",
    category: "international",
    summary:
      "Generally Open for all Streams, Undergraduate engineering degree at top global universities in USA, Canada, Europe through SAT.",
    eligibility:
      "10+2 with PCM; SAT + TOEFL/IELTS required. Some universities may require AP/IB subjects.",
    exams: ["SAT"],
    colleges: [
      "MIT (USA)",
      "Stanford University",
      "University of Toronto",
      "National University of Singapore",
      "Technical University of Munich"
    ],
    source: "College Board SAT website & university portals.",
    keywords: ["engineering abroad", "sat", "international"],
  },
  {
    id: "sat-business",
    name: "BBA/B.Com/BSBA (Business & Management Abroad via SAT)",
    stream: "all",
    category: "international",
    summary:
      "Generally Open for all Streams, Business and Management programs abroad via SAT, preparing students for global careers.",
    eligibility:
      "10+2 any stream; SAT + TOEFL/IELTS required.",
    exams: ["SAT"],
    colleges: [
      "Wharton School, University of Pennsylvania",
      "NYU Stern",
      "University of British Columbia",
      "London School of Economics"
    ],
    source: "College Board SAT website & global university portals.",
    keywords: ["business abroad", "sat", "bba", "management"],
  },
  {
    id: "sat-arts",
    name: "Liberal Arts / Humanities Programs Abroad (via SAT)",
    stream: "all",
    category: "international",
    summary:
      "Generally Open for all Streams, Study social sciences, economics, psychology, international relations abroad after 12th using SAT.",
    eligibility:
      "10+2 any stream; SAT + TOEFL/IELTS required.",
    exams: ["SAT"],
    colleges: [
      "Harvard College",
      "Yale University",
      "University of Amsterdam",
      "University of Melbourne"
    ],
    source: "College Board SAT official site.",
    keywords: ["liberal arts", "humanities", "abroad", "sat"],
  },
];

export default INTERNATIONAL;
